import { CustomError } from "./CustomError";

export class ExternalError extends CustomError {
    readonly external = true;

    constructor(...params: ConstructorParameters<typeof CustomError>) {
        super(...params);

        // Set the prototype explicitly to maintain instanceof checks
        // See https://www.dannyguo.com/blog/how-to-fix-instanceof-not-working-for-custom-errors-in-typescript/
        Object.setPrototypeOf(this, ExternalError.prototype);

        this.name = "ExternalError";
    }
}
